export class TimeRecordModel {
  gameTime: number;
  startedTime: number;
  timeString: string;

  constructor() {
    this.gameTime = 0;
    this.timeString = '0:00';
    this.startedTime = new Date().getTime();
  }
}
